import React, { useState, useRef, useEffect } from 'react';
import { Form } from '@unform/web';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Text } from '@unimed-fesp/components';
import { Creators as AuthActions } from '../../store/ducks/auth';

import history from '../../services/history';

import {
  USER_KEY,
  getLocalObj,
  excludeData,
  getUserData,
  getRefreshToken,
  isAccessTokenValid,
  getTokenAccessToken,
} from '../../services/auth';

import { LoginLink, DificuldadesAcessoContainer } from './styles';

import FormForgottenPassword from '../../components/organisms/FormForgottenPassword';

const { REACT_APP_EMAIL_DIFICULDADES_ACESSO } = process.env;

function RedefinirSenha() {
  const { loggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const queryEmail = params.get('email');
  const isTokenError = false || params.get('isTokenError');
  const mailTo = `mailto:${REACT_APP_EMAIL_DIFICULDADES_ACESSO}`;

  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);

  function handleSubmitForgottenPassword(data) {
    dispatch(AuthActions.getRecuperarSenhaRequest(data));
    setIsEmailSent(true);
  }

  function handleSubmitVoltarParaLogin() {
    window.location.replace('/novo/login');
  }

  useEffect(() => {
    if (loggedIn) history.push('/novo/lista');

    if (getLocalObj(USER_KEY) && !loggedIn) {
      if (getTokenAccessToken() && isAccessTokenValid()) {
        dispatch(AuthActions.signInRequest(getUserData()));
      } else if (getRefreshToken() && !isAccessTokenValid()) {
        dispatch(AuthActions.refreshInvalidTokenRequest(getTokenAccessToken()));
      } else {
        excludeData();
        dispatch(AuthActions.signOut());
      }
    }
  }, [dispatch, loggedIn]);

  return (
    <Form
      ref={formRef}
      onSubmit={
        !isEmailSent
          ? handleSubmitForgottenPassword
          : handleSubmitVoltarParaLogin
      }
    >
      <FormForgottenPassword
        setIsEmailValid={setIsEmailValid}
        isEmailSent={isEmailSent}
        queryEmail={queryEmail}
        isTokenError={isTokenError}
      />
      <Button
        tipo="primary"
        marginLeft={isEmailSent ? 150 : 189.5}
        marginTop={25}
        borderRadius={5}
        border="#00995d"
        height={40}
        width={isEmailSent ? 210 : 141}
        type="submit"
        justifyCenter
        alignCenter
        marginBottom={25}
        disabled={!isEmailValid}
        font="16px unimed_slabregular"
      >
        {isEmailSent ? 'voltar para o login' : 'enviar'}
      </Button>
      {isEmailSent && (
        <DificuldadesAcessoContainer>
          <Text marginRight={8} text="dificuldades no acesso?" />
          <LoginLink title={REACT_APP_EMAIL_DIFICULDADES_ACESSO} href={mailTo}>
            fale com o nosso Suporte.
          </LoginLink>
        </DificuldadesAcessoContainer>
      )}
    </Form>
  );
}

export default RedefinirSenha;
